import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export default class StoreAccessRight {
  public static VIEW_STORES: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel <= 2 || menuDisplayLevel >= 4;
}
